<script>
import {defineComponent} from 'vue'
import {Swiper, SwiperSlide} from 'swiper/vue'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import {Link} from "@inertiajs/vue3";
import architects_img from '@img/b2b/architects/top-bg.png';
import builders_img from '@img/b2b/builders/top-bg.png';
import designers_img from '@img/b2b/designers/top-bg.png';

export default defineComponent({
    name: "B2BSlider",
    components: {Swiper, SwiperSlide, Link},
    data() {
        return {
            swiper: null,
            items: [
                {
                    title: 'B2B для строителей',
                    img: builders_img,
                    link: '/b2b/for-builders'
                },
                {
                    title: 'B2B для дизайнеров',
                    img: designers_img,
                    link: '/b2b/for-architect'
                },
                {
                    title: 'B2B для Архитекторов',
                    img: architects_img,
                    link: '/b2b/for-designer'
                },
            ],
            breakpoints: {
                320: {slidesPerView: 1.2, spaceBetween: 10, loop: true},
                640: {slidesPerView: 2.2, spaceBetween: 15, loop: true},
                1024: {slidesPerView: 3, spaceBetween: 15},
                1400: {slidesPerView: 3, spaceBetween: 20},
            },
        }
    },
    methods: {
        route() {
            return route
        },
        setSwiper(swiperInstance) {
            this.swiper = swiperInstance
        },
        slideNext() {
            this.swiper?.slideNext()
        },
        slidePrev() {
            this.swiper?.slidePrev()
        },
    }
})
</script>

<template>
    <div class="relative"
         @touchstart.capture.stop="() => {}"
         @touchmove.capture.stop="() => {}"
         @touchend.capture.stop="() => {}">
        <Swiper :loop="false" :breakpoints="breakpoints" @swiper="setSwiper" class="h-[150px] pagination-base">
            <SwiperSlide v-for="(item, idx) in items" :key="idx">
                <Link :href="item.link"
                      class="bg-black block relative h-full rounded-3xl overflow-hidden group">
                    <div :style="{ backgroundImage: `url(${item.img})` }"
                         class="w-full absolute inset-0  bg-contain bg-no-repeat bg-bottom transition-transform duration-500 group-hover:scale-105"/>
                    <div class="w-full absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent"/>
                    <h3 class="w-full text-center absolute bottom-6 left-1/2 transform -translate-x-1/2 text-white text-xl font-semibold">
                        {{ item.title }}
                    </h3>
                </Link>
            </SwiperSlide>
        </Swiper>
    </div>
</template>

<style scoped lang="scss">
/* стили пагинации */
.pagination-base {
    .swiper-pagination-bullets {
        bottom: 8px !important;
    }

    .swiper-pagination-bullet {
        width: 24px;
        height: 4px;
        margin: 0 4px !important;
        opacity: 0.4;
        border-radius: 2px;
        background: #FFD700;
        transition: opacity .3s;
    }

    .swiper-pagination-bullet-active {
        opacity: 1;
    }
}
</style>
